export const IsEmpty = (token) => {
    if(!(typeof token === 'string' || token instanceof String)){
        token = String(token);
    }
    return token.length <= 0;
};